import { BOOK_TITLE, BOOK_SUBTITLE_SHORT, BOOK_AUTHOR, BOOK_PRICE, BOOK_DESCRIPTION, SITE_URL } from '../../lib/constants';

export function SEO() {
  const fullTitle = `${BOOK_TITLE}: ${BOOK_SUBTITLE_SHORT}`;

  const productSchema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: fullTitle,
    description: BOOK_DESCRIPTION,
    image: `${SITE_URL}/MoneySkillsforYourTwenties.jpg`,
    author: {
      '@type': 'Person',
      name: BOOK_AUTHOR,
    },
    offers: {
      '@type': 'Offer',
      price: BOOK_PRICE,
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      url: SITE_URL,
    },
    category: 'Books > Personal Finance',
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: 'Home',
        item: SITE_URL,
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: BOOK_TITLE,
        item: SITE_URL,
      },
    ],
  };

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={BOOK_DESCRIPTION} />
      <meta name="author" content={BOOK_AUTHOR} />
      <link rel="canonical" href={SITE_URL} />

      {/* Open Graph */}
      <meta property="og:type" content="product" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={BOOK_DESCRIPTION} />
      <meta property="og:image" content={`${SITE_URL}/MoneySkillsforYourTwenties.jpg`} />
      <meta property="og:url" content={SITE_URL} />
      <meta property="og:site_name" content={BOOK_TITLE} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={BOOK_DESCRIPTION} />
      <meta name="twitter:image" content={`${SITE_URL}/MoneySkillsforYourTwenties.jpg`} />

      {/* JSON-LD */}
      {/* biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD structured data, content is app-controlled */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(productSchema) }} />
      {/* biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD structured data, content is app-controlled */}
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }} />
    </>
  );
}
